export const PREV_DATE = 'PREV_DATE'
export const NEXT_DATE = 'NEXT_DATE'
export const CHANGE_DATE = 'CHANGE_DATE'
export const SHOW_DATEPICKER = 'SHOW_DATEPICKER'
export const GET_MAINDATA = 'GET_MAINDATA'
export const CHANGE_MAINDATA = 'CHANGE_MAINDATA'
